export default "{\n    \"title\": \"Asignar a miembro del personal\",\n    \"subtitle\": \"Crear y asignar órdenes de trabajo a miembros del personal\"\n}\n"